export let chime = new Audio(require('../../assets/er-alert.mp3'))

export function playSound () {
  try {
    chime.play()
  } catch (error) {
    console.error('Error playing audio file: ', error)
  }
}
